import { StateCreator } from "zustand";
import { Storage } from "../index";

export interface ProgressBarSlice {
	progressStep: number | null;
	totalProgressSteps: number | null;
	progressStepStatus: boolean[] | undefined;
	setProgressStep: (progressStep: number | null) => void;
	advanceProgressStep: () => void;
	decrementProgressStep: () => void;
	initProgressBar: (totalSteps: number, stepStatus?: boolean[]) => void;
	clearProgressBar: () => void;
}

const initialState = {
	progressStep: null,
	totalProgressSteps: null,
	progressStepStatus: undefined,
};
export const createProgressBarSlice: StateCreator<Storage, [], [], ProgressBarSlice> = (set) => ({
	...initialState,
	setProgressStep: (progressStep: number | null) =>
		set(() => ({
			progressStep,
		})),
	decrementProgressStep: () =>
		set((state) => {
			if (state.progressStepStatus && state.progressStep && state.progressStep - 2 >= 0)
				state.progressStepStatus[state.progressStep - 2] = false;
			return {
				progressStep: state.progressStep && state.progressStep > 1 ? state.progressStep - 1 : 1,
			};
		}),
	advanceProgressStep: () =>
		set((state) => {
			if (state.progressStepStatus && state.progressStep && state.progressStepStatus?.length >= state.progressStep)
				state.progressStepStatus[state.progressStep - 1] = true;
			return {
				progressStep: state.progressStep ? state.progressStep + 1 : 1,
			};
		}),
	initProgressBar: (totalSteps: number, stepStatus?: boolean[]) =>
		set(() => {
			const progressStep = stepStatus?.findIndex((value) => value === false);
			return {
				totalProgressSteps: totalSteps,
				progressStep: progressStep && progressStep > -1 ? progressStep + 1 : 1,
				progressStepStatus: stepStatus,
			};
		}),
	clearProgressBar: () =>
		set(() => ({
			totalProgressSteps: null,
			progressStep: null,
			progressStepStatus: undefined,
		})),
});
